(function () {
    'use strict';

    angular
        .module('invesfleet')
        .factory('modals', modals);

    modals.$inject = ['ModalService', 'genericDataService', '$rootScope', 'clientService', 'logEmpleadosService', 'notificationService', '$q', 'empleadosService', 'common'];

    function modals(ModalService, genericDataService, $rootScope, clientService, logEmpleadosService, notificationService, $q, empleadosService, common) {
        var service = {
            showModal: showModal
        };

        return service;

        function showModal(entity, callback, args) {
            /*jshint maxcomplexity:false */
            $rootScope.blurry = true;
    
            switch (entity) {
                case 'colors':
                    colorAddModal(callback);
                    break;
                case 'clients':
                    clientsAddModal(callback, args);
                    break;
                case 'regularizar':
                    regularizarAddModal(callback, args);
                    break;
                case 'contrato':
                     contratoAddModal(callback, args);
                     break;
                case 'anadirObservacion':
                     anadirObservacion(callback);
                     break;
                case 'showMap':
                    showMap(callback);
                    break;
                case 'collective':
                    collectiveAddModal(callback);
                    break;
                case 'model':
                    modelAddModal(callback);
                    break;
                case 'brand':
                    brandAddModal(callback);
                    break;
                case 'vehicle':
                    vehicleAddModal(callback);
                    break;
                case 'orderType':
                    orderTypeAddModal(callback);
                    break;
                case 'damage':
                    damageAddModal(callback);
                    break;
                case 'base':
                    baseAddModal(callback);
                    break;
                case 'partners':
                    partnersAddModal(callback);
                    break;
                case 'group':
                    groupAddModal(callback);
                    break;
                case 'driver':
                    driverAddModal(callback);
                    break;
                case 'workshop':
                    workshopAddModal(callback);
                    break;
                case 'obra':
                    obraAddModal(callback);
                    break;
                default:
                    return;
            }
        }

        function colorAddModal(callback) {
            ModalService.showModal({
                templateUrl: 'app/views/modals/colorsTemplate.html',
                controller:
                function (close) {
                    var vm = this;

                    vm.id = null;
                    vm.name = null;

                    vm.save = function () {
                        var color = {
                            descripcion: vm.name,
                            id: vm.id
                        };

                        //Llamada api crear entidad
                        genericDataService.addColor(color).then(
                            function () { callback(); }
                        );

                        closeModal();
                        close();
                    };

                    vm.cancel = function () {
                        closeModal();
                        close();
                    };
                },
                controllerAs: 'vm'
            });
        }

        function clientsAddModal(callback, empresaId) {
            ModalService.showModal({
                templateUrl: 'app/views/modals/clientsTemplate.html',
                controller:
                function (close) {
                    var vm = this;

					vm.client = {};
					vm.existNif = false;
                    vm.genericData = {
                        empresas:{
                            list: null,
                            selected: { id: empresaId }
                        },
                        paises: {
                            list: null,
                            selected: { id: null }
                        },
                        provinces: {
                            list: null,
                            selected: { id: null }
                        },
                        poblaciones: {
                            list: null,
                            selected: { id: null }
                        },
                        tipoCliente: {
                            list: [
                                {id : 0, nombre : 'Cliente'},
                                {id : 1, nombre : 'Particular'},
                                {id : 2, nombre : 'Cliente Potencial'},
                                {id : 3, nombre : 'Cía.Aseguradora'},
                            ],
                            selected: { id: null }
                        }
                    };

                    vm.onPaisChange = onPaisChange;
                    vm.onProvChange = onProvChange;

                    (function(){
                        vm.genericData.paises.loading = true;
                            genericDataService.getPaises(null)
                            .then(function (res) {
                                vm.genericData.paises.loading = false;
                                vm.genericData.paises.list = res; 
                                selectChanged(vm.genericData.paises.list, vm.genericData.paises.selected, false);
                            });

                        vm.genericData.empresas.loading = true;
                        genericDataService.getEmpresas()
                            .then(function (res) {
                                vm.genericData.empresas.loading = false;
                                vm.genericData.empresas.list = res;
                                selectChanged(vm.genericData.empresas.list, vm.genericData.empresas.selected);
                            });
                    })();


                    function onPaisChange() {
                        var pais = vm.genericData.paises.selected && vm.genericData.paises.selected.id;
                        getProvincias(pais);
                    }
                    function onProvChange() {
                        var prov = vm.genericData.provinces.selected && vm.genericData.provinces.selected.id;
                        getPoblaciones(prov);
                    }

                    // Get the delivery provinces data -> DEPENDS ON: country
                    function getProvincias(pais) {
                        if (pais == null) {
                            vm.genericData.provinces.list = null;
                            if (vm.genericData.provinces.selected.id != null) {
                                vm.genericData.provinces.selected = { id: null, nombre: null };
                            }
                        } else {
                            vm.genericData.provinces.loading = true;
                            genericDataService.getProvinces(null, pais)
                                .then(function (res) {
                                    vm.genericData.provinces.loading = false;
                                    vm.genericData.provinces.list = res;
                                    selectChanged(vm.genericData.provinces.list,
                                        vm.genericData.provinces.selected, false);
                                });
                        }
                    }

                    // Get the delivery populations data -> DEPENDS ON: province
                    function getPoblaciones(provincia) {
                        if (provincia == null) {
                            vm.genericData.poblaciones.list = null;
                            if (vm.genericData.poblaciones.selected.id != null) {
                                vm.genericData.poblaciones.selected = { id: null, nombre: null };
                            }
                        }
                        else {
                            vm.genericData.poblaciones.loading = true;
                            genericDataService.getPopulations(null, provincia)
                                .then(function (res) {
                                    vm.genericData.poblaciones.loading = false;
                                    vm.genericData.poblaciones.list = res;
                                    selectChanged(vm.genericData.poblaciones.list,
                                        vm.genericData.poblaciones.selected, false);
                                });
                        }
                    }

					vm.warningCheckExist = function () {
                        clientService.checkExistingNif(vm.genericData.empresas.selected.id, vm.client)
                        .then(function (res) {
							vm.existNif = res;
						});
					};

                    vm.save = function () {
                        vm.client.empresaId = vm.genericData.empresas.selected.id;
                        vm.client.pais = vm.genericData.paises.selected.nombre;
                        vm.client.provincia = vm.genericData.provinces.selected.nombre;
                        vm.client.poblacion = vm.genericData.poblaciones.selected.nombre;
                        vm.client.tipoClienteId = vm.genericData.tipoCliente.selected.id;



                        clientService.addClient(vm.client).then(function(res){
                            //vm.client.clienteId = res;
                            var id = res.clienteId;
                            callback(id);
                            vm.cancel();
                        });
                    };

                    vm.cancel = function () {
                        closeModal();
                        close();
                    };
                },
                controllerAs: 'vm'
            });
        }

         function regularizarAddModal(callback, args) {
             ModalService.showModal({
                 templateUrl: 'app/views/modals/regularizarTemplate.html',
                 controller: function (close) {
                     var vm = this;
                     vm.gruposEstado = {};
                     vm.hIni = null;
                     vm.hFin = null; 
                     vm.observaciones = null; 
                     vm.option = args.option; 
                     vm.fechaIni = args.fechaIni;
                     vm.changedDay = false; 
                     vm.modificar = args.option != undefined && args.index != undefined; 

                     (function () {
                         logEmpleadosService.getGruposEstado().then(function(response){
                            vm.gruposEstado.list = response; 
                            if(args.tipoEmpleado == 1) {
                                vm.gruposEstado.list = vm.gruposEstado.list.filter(x=> x.grupoEstadoEmpleadoId == 1 || x.grupoEstadoEmpleadoId == 3);
                            } 
                            vm.gruposEstado.selected = vm.gruposEstado.list[0];
                            if (vm.modificar) {
                                vm.hIni = new Date(Date.parse(vm.option.fechaIni));
                                vm.hFin = new Date(Date.parse(vm.option.fechaFin));
                                vm.observaciones = vm.option.observaciones;
                                var idx = vm.gruposEstado.list.findIndex(x => x.grupoEstadoEmpleadoId == vm.option.grupoEstadoEmpleadoId);
                                vm.gruposEstado.selected = vm.gruposEstado.list[idx];
                            }
                            else {
                                 vm.hIni = new Date(Date.parse(vm.option.fechaFin));
                                 vm.hFin = new Date(Date.parse(moment(vm.option.fechaFin).add(1, 'hours')));
                            }
                         })
                         
                     })();

                     vm.getDuracion = function () {
                         if(vm.hIni != null && vm.hFin != null) {
                            var difference = (vm.hFin - vm.hIni) / 1000;
                            return secondsToHoursAndMinutes(difference);
                           
                        }
                         else {
                             return '-'; 
                         }

                    };

                     vm.save = function () {
                        if(checkHour() && checkEstado()) {
                            var action = 1; 
                            if(vm.modificar == true) {
                                action = vm.option.accion == 0 ? 2 : vm.option.accion;
                            }
                            callback(vm.hIni, vm.hFin, vm.gruposEstado.selected, vm.observaciones, (vm.hFin - vm.hIni) / 1000, args.index, action);
                            vm.cancel();
                        }  
                     };

                     function sendErrorRequire(messageValue) {
                         notificationService.sendAppNotification({
                             message: messageValue,
                             positionY: 'top',
                             positionX: 'right',
                             delay: 3000,
                             type: 'error'
                         });
                     }

                    function secondsToHoursAndMinutes(seconds) {
                       var horas = "";
                       if (seconds < 0) {
                           horas = "-";
                       }
                       horas += Math.abs(Math.trunc(seconds / 3600)).toString() + " h ";
                       var minutes = Math.abs(Math.round((seconds % 3600) / 60)).toString() + " min";
                       return horas + minutes;
                    }

                     function checkHour() {
                         var bool = true; 
                         if(vm.hIni == null) bool = false; 
                         else if(vm.hFin == null) bool = false; 
                         else if(vm.hFin <= vm.hIni) bool = false; 
                         if (bool == false) sendErrorRequire("Horas no válidas!");

                         return bool; 
                     }
                       function checkEstado() {
                            var bool = vm.gruposEstado.selected.grupoEstadoEmpleadoId != null; 
                            if (bool == false) sendErrorRequire("No ha seleccionado estado!");
                            return bool; 

                       }

                     vm.cancel = function () {
                         closeModal();
                         close();
                     };
                 },
                 controllerAs: 'vm'
             });
         }

         function anadirObservacion(callback) {
             ModalService.showModal({
                 templateUrl: 'app/views/modals/anadirObservacionTemplate.html',
                 controller: function (close) {
                     var vm = this;
                     vm.observacion = '';

                     vm.rechazar = function () {
                        callback(vm.observacion);
                        vm.cancel(); 
                     };

                     vm.cancel = function () {
                         closeModal();
                         close();
                     };
                },
                 controllerAs: 'vm'
            });
         }

         function contratoAddModal(callback, args) {
             ModalService.showModal({
                 templateUrl: 'app/views/modals/contratoTemplate.html',
                 controller: function (close) {
                     var vm = this;
                     vm.contrato = {};
                     vm.tiposContrato = {
                         list: [
                             {
                                 id: 0, 
                                 nombre: 'Indefinido'},
                             {
                                 id: 1,
                                 nombre: 'Temporal'
                             },
                             {
                                 id: 2,
                                 nombre: 'Prácticas'
                             },
                             {
                                 id: 3,
                                 nombre: 'Contratista'
                             },
                             {
                                 id: 4,
                                 nombre: 'Agencia'
                             },
                              {
                                  id: 5,
                                  nombre: 'Formación y aprendizaje'
                              },
                         ], 
                         selected: {}

                     };

                     vm.tiposHora = {
                         list: [{
                                 id: 0,
                                 nombre: 'Diárias'
                             },
                             {
                                 id: 1,
                                 nombre: 'Semanales'
                             }
                         ],
                         selected : {}
                     };

                     (function () {
                         if(args.contrato != null)  {
                            vm.contrato = args.contrato; 
                            vm.contrato.fechainicio = new Date(vm.contrato.fechainicio); 
                            vm.contrato.fechafin = new Date(vm.contrato.fechafin); 
                         }
                        vm.tiposContrato.selected = common.isNullOrUndefined(vm.contrato.tipoContrato) ? vm.tiposContrato.list[0] : vm.tiposContrato.list[vm.contrato.tipoContrato]; 
                        vm.tiposHora.selected = common.isNullOrUndefined(vm.contrato.tipoHoras) ? vm.tiposHora.list[0] : vm.tiposHora.list[vm.contrato.tipoHoras];
                        
                     })();

                     vm.save = function () {
                         if (check()) {
                             if(vm.contrato.contratoId == null) {
                                 vm.contrato.contratoId = 0;
                             }
                             vm.contrato.tipoHoras = vm.tiposHora.selected.id; 
                             vm.contrato.tipoContrato = vm.tiposContrato.selected.id;
                             empleadosService.createUpdateContrato({contratoId: vm.contrato.contratoId, fechainicio: vm.contrato.fechainicio, fechafin: vm.contrato.fechafin, horasContrato: vm.contrato.horasContrato, tipoContrato: vm.contrato.tipoContrato, tipoHoras: vm.contrato.tipoHoras, empleadoId: args.empleado}).then(function(response) {
                                callback();
                                vm.cancel();
                             }); 
                         } 

                     };

                     function check() {
                        if (common.isNullOrUndefined(vm.tiposHora.selected.id)) {
                            sendErrorRequire('Tiene que seleccionar un tipo de horas');
                            return false;
                        }
                         else if (common.isNullOrUndefined(vm.tiposContrato.selected.id)) {
                             sendErrorRequire('Tiene que seleccionar un tipo de contrato'); 
                             return false; 
                         }
                         else if (common.isNullOrUndefined(vm.contrato.horasContrato) || vm.contrato.horasContrato < 0) {
                             sendErrorRequire('El número de horas tiene que ser un valor positivo');
                             return false;
                         }
                        else if (common.isNullOrUndefined(vm.contrato.fechainicio) || common.isNullOrUndefined(vm.contrato.fechafin) || vm.contrato.fechafin < vm.contrato.fechainicio) {
                            if (vm.tiposContrato.selected.id == 0 && common.isNullOrUndefined(vm.contrato.fechafin) && !common.isNullOrUndefined(vm.contrato.fechainicio)) return true;
                            else {
                                sendErrorRequire('Fechas no válidas');
                                return false; 
                            }
                        }
                         return true; 
                     }

                     function sendErrorRequire(messageValue) {
                         notificationService.sendAppNotification({
                             message: messageValue,
                             positionY: 'top',
                             positionX: 'right',
                             delay: 3000,
                             type: 'error'
                         });
                     }

                     vm.cancel = function () {
                         closeModal();
                         close();
                     };
                 },
                 controllerAs: 'vm'
             });
         }


         function showMap(coordenadas) {
             ModalService.showModal({
                 templateUrl: 'app/views/modals/mapAddressJornadaTemplate.html',
                 controller: function (close) {
                    var vm = this;
                    vm.lat = coordenadas.lat;
                    vm.lng = coordenadas.lng;
                    vm.address = null;

                    (function () {
                         getAddress(vm.lat, vm.lng).then(function(address) {
                             vm.address = address.formatted_address.toString();
                         });
                     })();

                    function getAddress(lat, long) {
                        var geocoder = new google.maps.Geocoder();
                        var latlng = new google.maps.LatLng(
                            parseFloat(lat),
                            parseFloat(long)
                        );
                        var deferred = $q.defer();
                        geocoder.geocode({
                                'latLng': latlng
                            },
                            function (results, status) {
                                if (status === google.maps.GeocoderStatus.OK) {
                                    if (results[0]) {
                                        /*jshint camelcase: false */
                                        deferred.resolve(results[0]);
                                        return;
                                    }
                                }
                                deferred.reject('Dirección no encontrada');
                            }
                        );
                        return deferred.promise;
                    };

                     vm.cancel = function () {
                        closeModal(); 
                        close(); 
                     };

                     
                 },
                 controllerAs: 'vm'
             });
         }

        function collectiveAddModal(callback) {
            ModalService.showModal({
                templateUrl: 'app/views/modals/collectiveTemplate.html',
                controller:
                function (close) {
                    var vm = this;

                    vm.name = null;

                    vm.save = function () {
                        var color = {
                            descripcion: vm.name,
                            id: vm.name
                        };

                        //Llamada api crear entidad
                        genericDataService.addColor(color).then(
                            function () { callback(); }
                        );

                        closeModal();
                        close();
                    };

                    vm.cancel = function () {
                        closeModal();
                        close();
                    };
                },
                controllerAs: 'vm'
            });
        }

        function modelAddModal(callback) {
            ModalService.showModal({
                templateUrl: 'app/views/modals/modelTemplate.html',
                controller:
                function (close) {
                    var vm = this;

                    vm.name = null;

                    vm.save = function () {
                        var color = {
                            descripcion: vm.name,
                            id: vm.name
                        };

                        //Llamada api crear entidad
                        genericDataService.addColor(color).then(
                            function () { callback(); }
                        );

                        closeModal();
                        close();
                    };

                    vm.cancel = function () {
                        closeModal();
                        close();
                    };
                },
                controllerAs: 'vm'
            });
        }

        function brandAddModal(callback) {
            ModalService.showModal({
                templateUrl: 'app/views/modals/brandTemplate.html',
                controller:
                function (close) {
                    var vm = this;

                    vm.name = null;

                    vm.save = function () {
                        var color = {
                            descripcion: vm.name,
                            id: vm.name
                        };

                        //Llamada api crear entidad
                        genericDataService.addColor(color).then(
                            function () { callback(); }
                        );

                        closeModal();
                        close();
                    };

                    vm.cancel = function () {
                        closeModal();
                        close();
                    };
                },
                controllerAs: 'vm'
            });
        }

        function vehicleAddModal(callback) {
            ModalService.showModal({
                templateUrl: 'app/views/modals/vehicleTemplate.html',
                controller:
                function (close) {
                    var vm = this;

                    vm.name = null;

                    vm.save = function () {
                        var color = {
                            descripcion: vm.name,
                            id: vm.name
                        };

                        //Llamada api crear entidad
                        genericDataService.addColor(color).then(
                            function () { callback(); }
                        );

                        closeModal();
                        close();
                    };

                    vm.cancel = function () {
                        closeModal();
                        close();
                    };
                },
                controllerAs: 'vm'
            });
        }

        function orderTypeAddModal(callback) {
            ModalService.showModal({
                templateUrl: 'app/views/modals/orderTypeTemplate.html',
                controller:
                function (close) {
                    var vm = this;

                    vm.name = null;

                    vm.save = function () {
                        var color = {
                            descripcion: vm.name,
                            id: vm.name
                        };

                        //Llamada api crear entidad
                        genericDataService.addColor(color).then(
                            function () { callback(); }
                        );

                        closeModal();
                        close();
                    };

                    vm.cancel = function () {
                        closeModal();
                        close();
                    };
                },
                controllerAs: 'vm'
            });
        }

        function damageAddModal(callback) {
            ModalService.showModal({
                templateUrl: 'app/views/modals/damageTemplate.html',
                controller:
                function (close) {
                    var vm = this;

                    vm.name = null;

                    vm.save = function () {
                        var color = {
                            descripcion: vm.name,
                            id: vm.name
                        };

                        //Llamada api crear entidad
                        genericDataService.addColor(color).then(
                            function () { callback(); }
                        );

                        closeModal();
                        close();
                    };

                    vm.cancel = function () {
                        closeModal();
                        close();
                    };
                },
                controllerAs: 'vm'
            });
        }

        function baseAddModal(callback) {
            ModalService.showModal({
                templateUrl: 'app/views/modals/baseTemplate.html',
                controller:
                function (close) {
                    var vm = this;


                    vm.name = null;
                    vm.id = null;
                    vm.bases = {
                        list: null,
                        selected: { id: -1, nombre: 'Nueva base' }
                    };

                    (function(){
                        vm.bases.loading = true;
                        genericDataService.getBases().then(function (data){
                            vm.bases.list = data;
                            vm.bases.list.unshift({id: -1, nombre: 'Nueva base'});
                            vm.bases.loading = false;
                        });
                    })();

                    vm.save = function () {
                        if(vm.bases.selected.id === -1){
                            callback({
                                nombre: vm.name,
                                id: vm.id
                            });
                        }else{
                            callback({
                                nombre: vm.bases.selected.nombre,
                                baseId: vm.bases.selected.id
                            });
                        }
                        closeModal();
                        close();
                    };

                    vm.cancel = function () {
                        closeModal();
                        close();
                    };
                },
                controllerAs: 'vm'
            });
        }

        function partnersAddModal(callback) {
            ModalService.showModal({
                templateUrl: 'app/views/modals/partnersTemplate.html',
                controller:
                function (close) {
                    var vm = this;

                    vm.name = null;

                    vm.save = function () {
                        var color = {
                            descripcion: vm.name,
                            id: vm.name
                        };

                        //Llamada api crear entidad
                        genericDataService.addColor(color).then(
                            function () { callback(); }
                        );

                        closeModal();
                        close();
                    };

                    vm.cancel = function () {
                        closeModal();
                        close();
                    };
                },
                controllerAs: 'vm'
            });
        }

        function groupAddModal(callback) {
            ModalService.showModal({
                templateUrl: 'app/views/modals/groupTemplate.html',
                controller:
                function (close) {
                    var vm = this;

                    vm.name = null;

                    vm.save = function () {
                        var color = {
                            descripcion: vm.name,
                            id: vm.name
                        };

                        //Llamada api crear entidad
                        genericDataService.addColor(color).then(
                            function () { callback(); }
                        );

                        closeModal();
                        close();
                    };

                    vm.cancel = function () {
                        closeModal();
                        close();
                    };
                },
                controllerAs: 'vm'
            });
        }

        function driverAddModal(callback) {
            ModalService.showModal({
                templateUrl: 'app/views/modals/driverTemplate.html',
                controller:
                function (close) {
                    var vm = this;

                    vm.name = null;

                    vm.save = function () {
                        var color = {
                            descripcion: vm.name,
                            id: vm.name
                        };

                        //Llamada api crear entidad
                        genericDataService.addColor(color).then(
                            function () { callback(); }
                        );

                        closeModal();
                        close();
                    };

                    vm.cancel = function () {
                        closeModal();
                        close();
                    };
                },
                controllerAs: 'vm'
            });
        }

        function workshopAddModal(callback) {
            ModalService.showModal({
                templateUrl: 'app/views/modals/workshopTemplate.html',
                controller:
                function (close) {
                    var vm = this;

                    vm.name = null;

                    vm.save = function () {
                        var color = {
                            descripcion: vm.name,
                            id: vm.name
                        };

                        //Llamada api crear entidad
                        genericDataService.addColor(color).then(
                            function () { callback(); }
                        );

                        closeModal();
                        close();
                    };

                    vm.cancel = function () {
                        closeModal();
                        close();
                    };
                },
                controllerAs: 'vm'
            });
        }

        function obraAddModal(callback) {
            ModalService.showModal({
                templateUrl: 'app/views/modals/obraTemplate.html',
                controller:
                function (close) {
                    var vm = this;

                    vm.name = null;

                    vm.save = function () {
                        var color = {
                            descripcion: vm.name,
                            id: vm.name
                        };


                        closeModal();
                        close();
                    };

                    vm.cancel = function () {
                        closeModal();
                        close();
                    };
                },
                controllerAs: 'vm'
            });
        }

        function closeModal(){
            $rootScope.blurry = false;
        }

        function selectChanged(list, selected, requireId) {
            requireId = (typeof requireId === 'undefined') ? true : requireId; //RequireId defaults to TRUE
            if (!list || !selected) { return; } //If the is no list or element exit
            if (list.length <= 0 || selected.id == null) { // Delete element unless it doesnt require id
                if (!requireId) {  return; }
                selected.nombre = null;
                selected.id = null;
                return;
            }
            var find = findByProperty(list, 'id', selected.id);
            if (find) {
                selected.nombre = find.nombre;
                selected.id = find.id;
            } else {
                selected.nombre = null;
                selected.id = null;
            }
        }
        function findByProperty(array, property, id) {
            if(array===null){ return null; }
            for (var i = 0; i < array.length; i++) {
                if (array[i][property] === id) {
                    return array[i];
                }
            }
            return null;
        }
    }
})();